import CsFormItem from "./form-item";
import CsFormCommon from "./form-common";
import CsFormBottom from "./form-bottom";
import Manager from "./manager";
import { deepClone } from "./utils";
export default {
  name: "CsFormGroup",
  components: { CsFormBottom },
  mixins: [CsFormItem, Manager, CsFormCommon],
  props: {
    ruleModule: {
      type: Array,
      required: true,
    },
    action: {
      type: Object,
      required: false,
      default: () => {
        return {};
      },
    },
    option: {
      type: Object,
      required: false,
      default: () => {
        return {};
      },
    },
    value: Object,
  },
  data() {
    const parseRule = (rule) => {
      // 同步action配置
      const actionOn = this.action[rule.field] || {};
      if (actionOn) {
        rule.on = Object.assign({}, rule.on || {}, actionOn);
      }
      // 同步components配置
      if (Object.prototype.hasOwnProperty.call(this.components, rule.type)) {
        rule.component = this.components[rule.type];
        rule.type = "custom";
      } else if (
        Object.prototype.hasOwnProperty.call(
          this.$COMMONUI.components,
          rule.type
        )
      ) {
        // 同步全局globalComponents配置
        rule.component = this.$COMMONUI.components[rule.type];
        rule.type = "custom";
      }
    };

    const _ruleModule = deepClone(this.ruleModule);
    const formData = {};
    const ruleList = [];
    const _rule = _ruleModule.reduce((arr, item) => {
      return arr.concat(item.rule);
    }, []);
    _rule.forEach((item) => {
      if (item.type === "row") {
        item.children &&
          item.children.forEach((child) => {
            parseRule(child);
            formData[child.field] = child.value;
            ruleList.push(child);
          });
      } else {
        parseRule(item);
        ruleList.push(item);
        formData[item.field] = item.value;
      }
    });
    return {
      formData,
      renderRuleModule: _ruleModule,
      renderRule: _rule,
      ruleList,
    };
  },
  render(h) {
    return (
      <div>
        <el-form
          class="cs-form cs-form-group"
          ref="form"
          attrs={{ model: this.formData, ...this.formAttrs }}
          label-width="100px"
        >
          <el-row>
            {this.renderRuleModule.map(({ span, offset, pull, push, rule }) => {
              return (
                <el-col span={span} offset={offset} pull={pull} push={push}>
                  {rule.map((item) => {
                    return this.renderFormItem(h, item);
                  })}
                </el-col>
              );
            })}
          </el-row>
          <cs-form-bottom
            loading={this.loading}
            class="cs-form-bottom-layout"
            attrs={{
              buttons: this.formAttrs.buttons,
              buttonsAlign: this.formAttrs.buttonsAlign,
            }}
            on={{ onSubmit: this.onSubmit, onReset: this.onReset }}
          ></cs-form-bottom>
        </el-form>
      </div>
    );
  },
};
